import theme from "themes/Theme";
import { IconProps } from "./IconProps";
import { alpha } from "@mui/material";

const TransferIcon: React.FC<IconProps> = ({ width = 64, height = 64 }) => {
  return (
    <svg height={height} viewBox="0 0 300 300" width={width}>
      <path
        d="M150.845,14.8c-74.562,0-135.002,60.443-135.002,135.004c0,74.553,60.44,134.996,135.002,134.996   c74.558,0,134.999-60.443,134.999-134.996C285.844,75.243,225.403,14.8,150.845,14.8z M150.845,265.714   c-64.018,0-115.913-51.901-115.913-115.91c0-64.017,51.896-115.91,115.913-115.91c64.014,0,115.912,51.893,115.912,115.91   C266.757,213.813,214.859,265.714,150.845,265.714z"
        fill={alpha(theme.palette.primary.main, 0.6)}
      />
      <path
        d="M255.271,149.804c0,57.676-46.748,104.428-104.425,104.428c-57.679,0-104.431-46.752-104.431-104.428   S93.167,45.376,150.845,45.376C208.522,45.376,255.271,92.128,255.271,149.804z"
        fill={alpha(theme.palette.primary.main, 1)}
      />
      <g>
        <path
          d="M81.834,161.005c0-33.187,28.716-60.611,66.023-65.079l-5.348-24.06l49.862,25.64l-32.814,51.083    l-7.127-32.113c-31.015,8.438-53.5,33.268-53.5,62.613c0,11.442,3.431,22.194,9.421,31.556    C92.138,198.597,81.834,180.857,81.834,161.005z"
          fill="#FFFFFF"
        />
        <path
          d="M153.304,203.642l5.158,24.1l-49.664-26.032l33.22-50.814l6.886,32.161    c31.07-8.193,53.75-32.831,53.987-62.184c0.084-11.438-3.257-22.215-9.177-31.627c16.127,12.176,26.29,29.999,26.138,49.843    C219.579,172.267,190.643,199.471,153.304,203.642z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  );
};

export default TransferIcon;
